import * as types from './types';

import { postRequest } from '../../services/requestService';
import { showErrorToast } from '../../services/notificationsService';

/**
 * Fetch entities for current buyer
 */
export const fetchEntitites = () => async (dispatch) => {
  const payload = {
    isFetchingEntities: false,
    entities: [],
  };
  dispatch({
    type: types.SET_IS_FETCHING_ENTITIES,
    payload: { isFetchingEntities: true },
  });

  try {
    const response = await postRequest('/buyers/entities/get-entities');
    const { entities } = response.data;
    payload.entities = entities;
  } catch (e) {
    showErrorToast(`Fetching entities failed: ${e.message}`);
  }
  dispatch({
    type: types.SET_ENTITIES,
    payload,
  });
};
